import { Tag } from '@moneyforward/ap-frontend-components';
import { useTranslation } from '@/i18n';
import { IconAi } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

export const LabelTagAI: FC = () => {
  const { t } = useTranslation();
  return (
    <Tag
      className={cx(['tagContainer'])}
      status='success'
      closable={false}
      outline={false}
      customIcon={<IconAi size={12} />}
    >
      {t('received_invoice_label_type')}
    </Tag>
  );
};
